import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

export function ResetPasswordPage() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  // If no session after callback, redirect to auth
  useEffect(() => {
    void supabase.auth.getSession().then(({ data }) => {
      if (!data.session) navigate('/auth', { replace: true });
    });
  }, [navigate]);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    if (password.length < 8) { setError('Password must be at least 8 characters'); return; }
    if (password !== confirm) { setError('Passwords do not match'); return; }
    setLoading(true);
    const { error: err } = await supabase.auth.updateUser({ password });
    if (err) {
      setError(err.message);
      setLoading(false);
    } else {
      setDone(true);
      setTimeout(() => navigate('/', { replace: true }), 2000);
    }
  }

  const S = {
    page: { minHeight: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'var(--bg-base)', padding: 20 },
    card: { width: '100%', maxWidth: 400, backgroundColor: 'var(--bg-surface)', border: '1px solid var(--border)', borderRadius: 16, padding: 32, display: 'flex', flexDirection: 'column' as const, gap: 24 },
    title: { fontSize: 22, fontWeight: 700, color: 'var(--text-primary)', margin: 0 },
    subtitle: { fontSize: 14, color: 'var(--text-muted)', margin: 0 },
    form: { display: 'flex', flexDirection: 'column' as const, gap: 12 },
    label: { display: 'flex', flexDirection: 'column' as const, gap: 5, fontSize: 13, fontWeight: 500, color: 'var(--text-secondary)' },
    input: { padding: '10px 12px', borderRadius: 8, border: '1px solid var(--border)', backgroundColor: 'var(--bg-base)', color: 'var(--text-primary)', fontSize: 14, outline: 'none', width: '100%', boxSizing: 'border-box' as const },
    btn: { width: '100%', padding: '11px 16px', borderRadius: 10, border: 'none', backgroundColor: 'var(--accent)', color: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer', marginTop: 4 },
    error: { padding: '10px 14px', borderRadius: 8, backgroundColor: 'var(--danger-muted, #fff0f0)', border: '1px solid var(--danger, #e53e3e)', color: 'var(--danger, #e53e3e)', fontSize: 13 },
    success: { padding: '10px 14px', borderRadius: 8, backgroundColor: 'oklch(22% 0.06 150)', border: '1px solid oklch(40% 0.15 150)', color: 'oklch(70% 0.2 150)', fontSize: 13 },
  };

  return (
    <div style={S.page}>
      <div style={S.card}>
        <div>
          <h1 style={S.title}>Reset your password</h1>
          <p style={S.subtitle}>Enter your new password below.</p>
        </div>
        {done ? (
          <div style={S.success}>Password updated! Redirecting…</div>
        ) : (
          <form onSubmit={handleSubmit} style={S.form}>
            {error && <div style={S.error}>{error}</div>}
            <label style={S.label}>
              New Password
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} style={S.input} />
            </label>
            <label style={S.label}>
              Confirm Password
              <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required style={S.input} />
            </label>
            <button type="submit" disabled={loading} style={S.btn}>
              {loading ? '…' : 'Update Password'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
